import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"card-container inspection\"><div class=\"flex\"><h2 class=\"header\">Protractor Demo Store</h2></div><div class=\"customer\"><button class=\"p-button p-component p-button p-component p-button-rounded btn-secondary sml mr-2\" type=\"button\" aria-label=\"Day\"><span class=\"p-button-label\">Day</span></button><button class=\"p-button p-component p-button p-component p-button-rounded btn-secondary sml mr-2\" type=\"button\" aria-label=\"Week\"><span class=\"p-button-label\">Week</span></button><button class=\"p-button p-component p-button p-component p-button-rounded btn-secondary sml mr-2\" type=\"button\" aria-label=\"Month\"><span class=\"p-button-label\">Month</span></button><button class=\"p-button p-component p-button p-component p-button-rounded btn-primary sml\" type=\"button\" aria-label=\"Quarter\"><span class=\"p-button-label\">Quarter</span></button></div></div>", 1)
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "wo-details" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "customer" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Current Car Count:"),
      /*#__PURE__*/_createTextVNode("37")
    ]),
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Current Tire Count:"),
      /*#__PURE__*/_createTextVNode("123")
    ])
  ])
], -1)
const _hoisted_4 = { class: "singles flex" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Gross Profit")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "value cond" }, "$27,876", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Gross Profit / Hour")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "value cond" }, "$75.98", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("% of Gross Sales")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "value cond" }, "23.56%", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "SALES"),
    /*#__PURE__*/_createTextVNode("|"),
    /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Q1, 2023")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Period: ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, " By Quarter", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", { class: "p-panel-header-icon p-link mr-1 ml-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "pi pi-chart-bar" })
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-cog" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-1 flex-column items" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
      /*#__PURE__*/_createElementVNode("h1", { style: {"margin":"0"} }, "Sales")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row flex-wrap justify-content-center align-items-center" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
          /*#__PURE__*/_createElementVNode("h4", null, "Closing Ratio"),
          /*#__PURE__*/_createElementVNode("p", { class: "value cond" }, "62.4%")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
          /*#__PURE__*/_createElementVNode("h4", null, "Avg. Estimate"),
          /*#__PURE__*/_createElementVNode("p", { class: "value cond" }, "$457.75")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
          /*#__PURE__*/_createElementVNode("h4", null, "Gross Sales"),
          /*#__PURE__*/_createElementVNode("p", { class: "value cond" }, "$121,765.98")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
          /*#__PURE__*/_createElementVNode("h4", null, "Gross Profit"),
          /*#__PURE__*/_createElementVNode("p", { class: "value cond" }, "$21,765.98")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-1 justify-content-center chart" }, [
    /*#__PURE__*/_createElementVNode("svg", { id: "chart-svg" })
  ])
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "LABOUR"),
  /*#__PURE__*/_createTextVNode("|"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Q1, 2023")
], -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Period: ")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("strong", null, " By Quarter", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-chart-pie" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-cog" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "grid col-12" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "grid col-12 title" }, [
  /*#__PURE__*/_createElementVNode("h1", { style: {"margin":"0"} }, "Labour")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "grid col-3 items" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "grid col-12 justify-content-center align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "item col-12" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
        /*#__PURE__*/_createElementVNode("h4", null, "Effective Labor Rate"),
        /*#__PURE__*/_createElementVNode("p", { class: "value cond" }, "$85.98")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "item col-12" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
        /*#__PURE__*/_createElementVNode("h4", null, "Average Hours Billed"),
        /*#__PURE__*/_createElementVNode("p", { class: "value cond" }, "4.67")
      ])
    ])
  ])
], -1)
const _hoisted_28 = { class: "flex col-9 justify-content-center chart" }

import * as d3 from 'd3';
    import Chart from 'primevue/chart';
    import { ref, onMounted } from "vue";
  
    
export default /*#__PURE__*/_defineComponent({
  name: 'ReportingV3',
  setup(__props) {

    const data = [
        { name: "A", value: 30 },
        { name: "B", value: 80 },
        { name: "C", value: 45 },
        { name: "D", value: 60 },
        { name: "E", value: 20 },
        { name: "F", value: 90 }
    ];

    onMounted(() => {
        barData.value = setBarData();
        barOptions.value = setBarOptions();
        pieData.value = setPieData();
        pieOptions.value = setPieOptions();

        //DRAW CHART
        drawChart(data);
    });
  
    const barData = ref();
    const barOptions = ref();
    const pieData = ref();
    const pieOptions = ref();
  
    // - Presented [value|hour] % in chart
    // - Billed [value|hour] % in chart
    // - Sold [value|hour] (same as ‘Billed’?) % in chart
  
    const setBarData = () => {
        return {
            labels: ['Presented', 'Sold', 'Billed'],
            datasets: [
                {
                    label: 'Labour',
                    data: [100, 73.2, 66.9],
                    backgroundColor: ['rgba(249, 115, 22, 0.2)', 'rgba(6, 182, 212, 0.2)', 'rgb(107, 114, 128, 0.2)'],
                    borderColor: ['rgb(249, 115, 22)', 'rgb(6, 182, 212)', 'rgb(107, 114, 128)'],
                    borderWidth: 1
                }
            ]
        };
    };
    const setBarOptions = () => {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
  
        return {
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                },
                y: {
                    beginAtZero: true,
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                }
            }
        };
    };
    const setPieData = () => {
      const documentStyle = getComputedStyle(document.body);
  
      return {
          labels: [' Parts Sales', ' Tire Sales', ' Labor Sales', ' Sublet Sales'],
          datasets: [
              {
                  data: [851, 702, 540, 325 ],
                  backgroundColor: [documentStyle.getPropertyValue('--cyan-500'), documentStyle.getPropertyValue('--orange-500'), documentStyle.getPropertyValue('--gray-500'), documentStyle.getPropertyValue('--green-500')],
                  hoverBackgroundColor: [documentStyle.getPropertyValue('--cyan-400'), documentStyle.getPropertyValue('--orange-400'), documentStyle.getPropertyValue('--gray-400'), documentStyle.getPropertyValue('--green-400')]
              }
          ]
      };
    };
    const setPieOptions = () => {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
  
        return {
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true,
                        color: textColor,
                    }
                }
            }
        };
    }

    const drawChart = (data: { name: string, value: number }[]) => {
        const width = 400;
        const height = 400;
        const radius = Math.min(width, height) / 2;

        // Create color scale
        const color = d3.scaleOrdinal()
            .domain(data.map(d => d.name))
            .range(d3.schemeCategory10);

        // Create pie layout
        const pie = d3.pie<{ name: string, value: number }>()
            .value(d => d.value)
            .sort(null);

        // Create arc generator
        const arc = d3.arc<d3.PieArcDatum<{ name: string, value: number }>>()
            .innerRadius(0)
            .outerRadius(radius);

        // Select the SVG element and set its dimensions
        const svg = d3.select("#chart-svg")
            .attr("width", width)
            .attr("height", height)
            .attr("viewBox", `0 0 ${width} ${height}`);

        // Append group element for the pie chart
        const pieGroup = svg.append("g")
            .attr("transform", `translate(${width / 2}, ${height / 2})`);

        // Create pie slices
        pieGroup.selectAll("path")
            .data(pie(data))
            .join("path")
            .attr("d", arc)
            .attr("fill", d => color(d.data.name))
            .attr("stroke", "white") // Add a white border around slices
            .style("stroke-width", "2px"); // Set the border width

        // Add labels to the pie slices
        pieGroup.selectAll("text")
            .data(pie(data))
            .join("text")
            .attr("transform", d => `translate(${arc.centroid(d)})`)
            .attr("text-anchor", "middle")
            .attr("font-size", "12px")
            .text(d => `${d.data.name}: ${d.data.value}`);
    }
  
  
return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Card, { class: "third" }, {
          title: _withCtx(() => [
            _hoisted_5
          ]),
          content: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_Card, { class: "third" }, {
          title: _withCtx(() => [
            _hoisted_7
          ]),
          content: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_Card, { class: "third" }, {
          title: _withCtx(() => [
            _hoisted_9
          ]),
          content: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_Panel, {
        id: "sales",
        toggleable: "",
        style: {"margin-bottom":"1rem"}
      }, {
        header: _withCtx(() => [
          _hoisted_11
        ]),
        icons: _withCtx(() => [
          _hoisted_12,
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("button", {
            class: "p-panel-header-icon p-link mr-1",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
          }, _hoisted_16),
          _createVNode(_component_Menu, {
            ref: "menu",
            id: "config_menu",
            model: _ctx.items,
            popup: ""
          }, null, 8, ["model"])
        ]),
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      }),
      _createVNode(_component_Panel, {
        id: "labour",
        toggleable: ""
      }, {
        header: _withCtx(() => [
          _hoisted_18
        ]),
        icons: _withCtx(() => [
          _hoisted_19,
          _hoisted_20,
          _createElementVNode("button", {
            class: "p-panel-header-icon p-link mr-1 ml-4",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
          }, _hoisted_22),
          _createElementVNode("button", {
            class: "p-panel-header-icon p-link mr-1",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
          }, _hoisted_24),
          _createVNode(_component_Menu, {
            ref: "menu",
            id: "config_menu",
            model: _ctx.items,
            popup: ""
          }, null, 8, ["model"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_unref(Chart), {
                type: "bar",
                data: barData.value,
                options: barOptions.value
              }, null, 8, ["data", "options"])
            ])
          ])
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})